import React from "react";

const HeroSection = () => (
  <section className="relative bg-gradient-to-r from-green-600 via-teal-500 to-blue-600 dark:from-green-700 dark:via-teal-600 dark:to-blue-700 text-white py-20">
    <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
      <h1 className="text-4xl sm:text-5xl font-bold mb-4">Smart Loan Planning, Simplified</h1>
      <p className="text-lg sm:text-xl mb-8">Calculate EMIs, compare rates, and plan your finances with ease.</p>
      <a
        href="#calculator"
        className="inline-block bg-white text-green-700 dark:bg-neutral-900 dark:text-white font-semibold px-8 py-3 rounded-full shadow-lg hover:shadow-xl transition"
      >
        Calculate Now
      </a>
    </div>
  </section>
);

export default HeroSection;
